module.exports = __webpack_public_path__ + "img/undraw_Statistics_re_kox4.8d5f775e.svg";